<template>
  <div class="find">
    <button @click="router.go(-1)">
      <svg width="36" height="36">
        <use xlink:href="@/assets/icons/sprite.svg#backBtn"></use>
      </svg>
    </button>
    <Input
      class="find__input"
      :isNoActivePlaceholder="true"
      type="text"
      placeholder="Найти продукты"
      :isIcon="true"
      v-model="modelValue"
    >
      <template v-slot:icon>
        <svg width="16" height="16">
          <use xlink:href="@/assets/icons/sprite.svg#search"></use>
        </svg>
      </template>
    </Input>
  </div>
</template>
<script setup lang="ts">
  import router from "@/router";
  import Input from "@/UI/Input.vue";
  import { ref, watch } from "vue";

  const props = defineProps({
    modelValue: {
      type: String,
    },
  });

  const modelValue = ref(props.modelValue);
  
  const emit = defineEmits(["update:modelValue"]);

  watch(
    () => modelValue.value,
    () => {
      emit("update:modelValue", modelValue.value);
    }
  );
</script>
<style lang="scss">
  .find {
    display: flex;
    gap: 12px;
    background-color: $white;

    .custom-input__text {
      height: auto;
    }

    &__input {
      flex: 1;
      width: 100%;
      transition: all 0.3s ease-in-out;
    }

    @include mediumMobile {
      height: 36px;
    }
  }
</style>
